var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDottedCircle = function SvgDottedCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.941,
    r: 27,
    fill: "#D9E7FD",
    fillOpacity: 0.4,
    stroke: "#2C79F7",
    strokeDasharray: "4 4",
    strokeWidth: 2
  })));
};
export { SvgDottedCircle as ReactComponent };
export default __webpack_public_path__ + "01d4b61705612b83e30f02b25d8416ab.svg";